import { Text } from '@thanx/uikit/text'
import { ReactComponent as ExternalLinkIcon } from 'assets/images/ic-external-link.svg'
import { ReactComponent as BulbIcon } from 'assets/images/img_bulb_2.svg'
import useCurrentMerchant from 'hooks/useCurrentMerchant'
import { buildTranslate } from 'locales'
import React from 'react'
import { Col, Row } from 'react-bootstrap-five'
import { getCurrentEnvironment } from 'utilities/urlUtils'
import BrameConfigurationDetails from './BrameConfigurationDetails'

const t = buildTranslate('games')

const BrameSetupNotice = () => {
  const merchant = useCurrentMerchant()

  // Generate configuration JSON (matching admin implementation structure)
  const getConfigurationData = () => {
    const environment = getCurrentEnvironment()
    const config: {
      merchantId: string
      merchantBrand: string
      env?: string
    } = {
      merchantId: merchant?.hashid || '',
      merchantBrand: merchant?.name || '',
    }

    // Only include env if not production (matching admin logic)
    if (environment !== 'production') {
      config.env = environment
    }

    return config
  }

  return (
    <Row className="mb-4">
      <Col>
        <div
          className="p-4 d-flex"
          style={{
            backgroundColor: '#f2f4f5',
            gap: '16px',
          }}
        >
          <div className="flex-shrink-0">
            <BulbIcon
              style={{
                width: '24px',
                height: '24px',
                fill: '#6a747f',
                marginTop: '8px',
              }}
            />
          </div>
          <div className="flex-grow-1">
            <div className="mb-3">
              <Text.SmallCaps3 color="#36424e">
                {t('enabled.notice.title')}
              </Text.SmallCaps3>
            </div>
            <div className="mb-3">
              <Text.BodyText4 color="#6a747f">
                {t('enabled.notice.description')}
              </Text.BodyText4>
            </div>
            <div className="mb-3">
              <a
                href="https://app.brame-gamification.com/dashboard"
                target="_blank"
                rel="noopener noreferrer"
                className="d-flex align-items-center text-decoration-none"
                style={{ gap: '4px' }}
              >
                <Text.BodyText4 tag="span" className="mb-0" color="primary">
                  {t('enabled.notice.linkText')}
                </Text.BodyText4>
                <ExternalLinkIcon
                  width="15"
                  height="15"
                  style={{ flexShrink: 0 }}
                />
              </a>
            </div>
            <BrameConfigurationDetails
              configurationData={getConfigurationData()}
            />
          </div>
        </div>
      </Col>
    </Row>
  )
}

export default BrameSetupNotice
